import {trace} from '@opentelemetry/api';
import {getWebAutoInstrumentations} from '@opentelemetry/auto-instrumentations-web';
import {ZoneContextManager} from '@opentelemetry/context-zone';
import {CompositePropagator, W3CBaggagePropagator, W3CTraceContextPropagator} from '@opentelemetry/core';
import {OTLPTraceExporter} from '@opentelemetry/exporter-trace-otlp-http';
import {registerInstrumentations} from '@opentelemetry/instrumentation';
import {Resource} from '@opentelemetry/resources';
import {WebTracerProvider} from '@opentelemetry/sdk-trace-web';
//exporters
import {BatchSpanProcessor, ConsoleSpanExporter, SimpleSpanProcessor} from '@opentelemetry/sdk-trace-web';
import {ATTR_SERVICE_NAME} from '@opentelemetry/semantic-conventions';

const startOtelInstrumentation = () => {
  const resourceSettings = new Resource({
    [ATTR_SERVICE_NAME]: `${process.env.NEXT_PUBLIC_ENV}-Faster`,
  });
  // The `newFasterExporter` is an instance of OTLPTraceExporter configured to send traces to OTLP backend.
  const newFasterExporter = new OTLPTraceExporter({
    url: process.env.NEXT_PUBLIC_TELEMETRY_OTLP_TRACES_EXPORTER_URL, // OTLP traces endpoint
  });

  const provider = new WebTracerProvider({
    resource: resourceSettings,
    spanProcessors: [
      new SimpleSpanProcessor(new ConsoleSpanExporter()),
      new BatchSpanProcessor(newFasterExporter, {
        maxQueueSize: 100,
        maxExportBatchSize: 50,
        scheduledDelayMillis: 500,
        exportTimeoutMillis: 30000,
      }),
    ],
  });

  // ZoneContextManager is a context manager implementation based on the Zone.js library. It enables context propagation within the application using zones.
  provider.register({
    contextManager: new ZoneContextManager(),
    // Configure the propagator to enable context propagation between services using the W3C Trace Headers
    propagator: new CompositePropagator({
      propagators: [new W3CBaggagePropagator(), new W3CTraceContextPropagator()],
    }),
  });

  console.log(`Registering Otel ${new Date().getMilliseconds()}`);
  // Registering instrumentations
  registerInstrumentations({
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-xml-http-request': {
          enabled: true,
          clearTimingResources: true,
          propagateTraceHeaderCorsUrls: [/.+/g],
        },
        '@opentelemetry/instrumentation-document-load': {
          enabled: true,
        },
        '@opentelemetry/instrumentation-user-interaction': {
          enabled: true,
        },
      }),
    ],
  });

  return trace.getTracer('default');
};

export {startOtelInstrumentation};
